import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {selectCurrentAddress, selectUserData} from '~/shared/store/selectors';
import {navigateToDefaultStartPage} from '~/shared/services/navigation';
import initManager from '~/shared/managers/initManager';
import store from '~/shared/store';
import {getCurrentLocation, pushRoute} from '~/shared/router';
import {fetchReordersIfNeeded} from '~/shared/utils/reorder/utils';
import {isAddress} from '~/shared/store/models';
import {getLocalizationService} from '~/shared/services/localisationService';

import {NewDesignHeader, PageWidthContainer} from '../page.styled';

import {ReorderPageComponent} from './ReorderPageComponent';

const ReorderPage = () => {
  const {t} = getLocalizationService();
  const currentAddress = useSelector(selectCurrentAddress);

  useEffect(() => {
    if (!currentAddress || !isAddress(currentAddress)) {
      return;
    }

    fetchReordersIfNeeded({addressId: currentAddress.addressId});
  }, [currentAddress]);

  initManager.useOnPageInit(() => {
    const user = selectUserData(store.getState());
    const location = getCurrentLocation();

    if (!user) {
      pushRoute(`/signin?returnUrl=/&successReturnUrl=${encodeURIComponent(location.path)}`);
    }
  });

  return (
    <>
      <NewDesignHeader title={t('reorder')} onBackClick={navigateToDefaultStartPage} />
      <PageWidthContainer>
        <ReorderPageComponent />
      </PageWidthContainer>
    </>
  );
};

export default ReorderPage;
